import { useRoute } from '@react-navigation/native'
import { useQuery } from '@tanstack/react-query'

import { useIsApplicationV2 } from '../../applicationDetails/hook'
import { getAutoComplete } from '../functions/autoComplete'

export const useAutoComplete = (
  searchValue: string,
  fieldId: number,
  ocFieldCode: string,
  dependencyValue: string = '',
  leadId?: string
) => {
  const { params, name } = useRoute()
  const { hash } = params ?? {}

  const isLOS = name === 'BrandsLOS' ? true : false

  const isV2 = useIsApplicationV2(hash)

  return useQuery({
    queryKey: [
      'cc/brands',
      useAutoComplete,
      searchValue,
      fieldId,
      hash,
      ocFieldCode,
      dependencyValue,
      leadId,
    ],
    queryFn: () =>
      getAutoComplete(
        searchValue,
        fieldId,
        hash,
        isLOS,
        ocFieldCode,
        isV2,
        dependencyValue,
        leadId
      ),
    enabled: false,
  })
}
